import { useEffect } from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { companyService } from 'ogp/services';
import { useAlert } from 'shared/components/alerts';
import { CreateLimitedCompanyForm } from '../pages/create-limited-company.schema';

const COC_NUMBER_REGEX = /^\d{8}$/;

export const usePrefillLimitedCompanyFromCocNumber = (
  formMethods: UseFormReturn<CreateLimitedCompanyForm>
) => {
  const { alertError } = useAlert();
  const { control, setValue, resetField } = formMethods;
  const cocNumber = useWatch({ control, name: 'cocNumber' });

  useEffect(() => {
    if (!COC_NUMBER_REGEX.test(cocNumber)) {
      return;
    }

    let isCancelled = false;

    const prefillCompany = async () => {
      try {
        const company = await companyService.getCompanyInfoByCocNumber(cocNumber);

        if (isCancelled) {
          return;
        }

        setValue('companyName', company.companyName);
        setValue('location', company.location);
      } catch (error) {
        if (isCancelled) {
          return;
        }

        setValue('companyName', '');
        resetField('location');
        alertError(error);
      }
    };

    prefillCompany();

    return () => {
      isCancelled = true;
    };
  }, [alertError, cocNumber, resetField, setValue]);
};
